import { Dispatch, SetStateAction, useState } from "react"
import ArrowDownIconDark from "~/assets/icons/ArrowDownIconDark";
import CustomizeProduct from "~/assets/icons/CustomizeProduct";

type Props = {
    noProducts: boolean,
    sortOptions: { label: string, field: string }[],
    sortValue: { label: string; field: string } | undefined,
    setSortValue: Dispatch<SetStateAction<{ label: string; field: string; } | undefined>>,
    setChange: Dispatch<SetStateAction<boolean>>,
    editURL: (filter: any) => void,
    getFilter: () => string,
    showFilter: boolean,
    setShowFilter: Dispatch<SetStateAction<boolean>>,
    loading: boolean
}

export default function ProductListHeader({ loading, noProducts, sortOptions, sortValue, setSortValue, setChange, editURL, getFilter, showFilter, setShowFilter }: Props) {

    const [showDropdown, setShowDropdown] = useState(false);

    const clickFilter = () => {
        setShowFilter(!showFilter);
    }

    const onSelect = (value: { label: string; field: string; } | undefined) => {
        setSortValue(value);
        setShowDropdown(false);
        let filter = getFilter();

        const values = value?.field.split('-') ?? []
        if (values[0].includes("price")) {
            values[0] = 'fromPrice'
        }
        filter = { ...filter, sort: [{ field: values[0], order: values[1] }], pagination: { page: 1, limit: 24 } };

        editURL(filter);

        setChange(true);
    }

    if (loading) return <Skeleton />

    if (noProducts) return <></>

    return (
        <div className="ProductList__filters grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="ProductList__left-section">
                <div className='ProductList__filter--button'>
                    <button className={`${showFilter && 'open'}`} type='button' onClick={clickFilter}>
                        Filters <span><CustomizeProduct /></span>
                    </button>
                </div>
                {sortValue && <div className='ProductList__featured--dropdown' onMouseLeave={() => setShowDropdown(false)}>
                    <button id="dropdownDefault" data-dropdown-toggle="dropdown" className="text-left inline-flex items-center" type="button" onClick={() => setShowDropdown(!showDropdown)}>
                        {sortValue?.label} <span><ArrowDownIconDark /></span>
                    </button>
                    <div id="dropdown" className={`z-10 ${!showDropdown && 'hidden'} bg-white divide-y divide-gray-100 rounded dark:bg-gray-700`}>
                        <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefault">
                            {sortOptions.map((v, i) =>
                                <li key={i}>
                                    <a key={i} href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => onSelect(v)}>
                                        {v?.label}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>}
            </div>
            {showFilter == false &&
                <div className="ProductList__right-section">
                    <div className="ProductList__clear-button">
                    </div>
                </div>
            }
        </div>
    )
}

const Skeleton = () => {
    return (
        <div className="ProductList__filters grid grid-cols-1 sm:grid-cols-2 gap-4 animate-pulse">
            <div className="ProductList__left-section">
                <div className='ProductList__filter--button'>
                    <button className="bg-gray-300 skeleton" type='button'>
                        Filters <span><CustomizeProduct /></span>
                    </button>
                </div>
                <div className='ProductList__featured--dropdown bg-gray-300'>
                    <button id="dropdownDefault" data-dropdown-toggle="dropdown" className="text-left inline-flex items-center" type="button">
                    </button>
                    <div id="dropdown" className={`z-10 hidden bg-white divide-y divide-gray-100 rounded dark:bg-gray-700`}>
                    </div>
                </div>
            </div>
        </div>
    )
}